import { useEffect } from "react";
import { useTheme } from "next-themes";
import { SEO } from "@/components/SEO";
import { LandingHeader } from "@/components/LandingHeader";
import { LandingHero } from "@/components/LandingHero";
import { LandingFeature } from "@/components/LandingFeature";
import { LandingInfo } from "@/components/LandingInfo";
import { LandingBenefits } from "@/components/LandingBenefits";
import { LandingAdSection } from "@/components/LandingAdSection";
import { LandingFeatures } from "@/components/LandingFeatures";
import { LandingTarget } from "@/components/LandingTarget";
import { LandingNews } from "@/components/LandingNews";
import { LandingPrivacy } from "@/components/LandingPrivacy";
import { LandingImpact } from "@/components/LandingImpact";
import { LandingPricing } from "@/components/LandingPricing";
import { LandingCTA } from "@/components/LandingCTA";
import { LandingFooter } from "@/components/LandingFooter";

const Landing = () => {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme("light");
  }, [setTheme]);

  return (
    <div className="min-h-screen w-full bg-background">
      <SEO
        title="KopfAI - IA de Bem-Estar Mental"
        description="KopfAI é um chat de IA direcionado ao bem-estar mental. Utilize princípios da Terapia Cognitivo-Comportamental (TCC) para entender seus pensamentos."
        canonical="https://kopfai.com/"
      />
      <LandingHeader />
      <main className="pt-20">
        <LandingHero />
        <div id="about">
          <LandingFeature />
          <LandingInfo />
        </div>
        <LandingBenefits />
        <LandingAdSection />
        <LandingFeatures />
        <LandingNews />
        <LandingTarget />
        <LandingPrivacy />
        <LandingImpact />
        <div id="pricing">
          <LandingPricing />
        </div>
        <LandingCTA />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
